import { observer } from 'mobx-react';
import React, { useEffect, useMemo, useCallback } from 'react';
// @ts-ignore
import * as Validator from 'validatorjs';

import { Title3 } from '../Typography';
import TextInput from '../TextInput';
import { about } from './index';
import styles from './styles.module.scss';

// Выносим TaxNumberField за пределы компонента для оптимизации производительности
const TaxNumberField = observer(({ validation }: { validation: any }) => {
  const handleTaxNumberChange = useCallback((value: string) => {
    about.values.details.tax_number = value;
  }, []);

  return (
    <TextInput
      onChange={handleTaxNumberChange}
      label="TAX number (VAT/TIN/EIN/INN)*"
      dataTest="tax"
      className={styles.textField}
      value={about.values.details.tax_number}
      error={validation.errors.first('tax_number')}
    />
  );
});

const Registration = observer(() => {
  // Определяем правила валидации в зависимости от типа компании
  const validationRules = useMemo(() => {
    const isCorporateEntity = ['partnership', 'corporation'].includes(
      about.values.details.company_form ?? '',
    );

    return isCorporateEntity
      ? {
          registration_number: 'required',
          tax_number: 'required',
        }
      : {
          tax_number: 'required',
        };
  }, [about.values.details.company_form]);

  const validation = useMemo(
    () =>
      new Validator(about.values.details, validationRules, {
        required: 'This field is required',
      }),
    [
      about.values.details.registration_number,
      about.values.details.tax_number,
      validationRules,
    ],
  );

  const isValid = validation.passes();

  useEffect(() => {
    about.isStepIsValid[3] = isValid;
  }, [isValid]);

  const isCorporateEntity = ['partnership', 'corporation'].includes(
    about.values.details.company_form ?? '',
  );
  const isSoleProprietor =
    about.values.details.company_form === 'sole-proprietor';

  // Оптимизированный обработчик для registration number
  const handleRegistrationNumberChange = useCallback((value: string) => {
    about.values.details.registration_number = value;
  }, []);

  return (
    <>
      {isCorporateEntity && (
        <>
          <div style={{ marginBottom: '20px' }}>
            <Title3 className={styles.subTitle}>
              Company Registration and TAX number*
            </Title3>
          </div>
          <TextInput
            onChange={handleRegistrationNumberChange}
            label="Registration number*"
            dataTest="registrationNumber"
            className={styles.textField}
            value={about.values.details.registration_number}
            error={validation.errors.first('registration_number')}
          />
          <TaxNumberField validation={validation} />
        </>
      )}

      {isSoleProprietor && (
        <>
          <div style={{ marginBottom: '20px' }}>
            <Title3 className={styles.subTitle}>
              Individual Entrepreneur TAX number*
            </Title3>
          </div>
          <TaxNumberField validation={validation} />
        </>
      )}
    </>
  );
});

export default Registration;
